import { jsx as _jsx } from "react/jsx-runtime";
import { Chip, Skeleton, Typography } from '@mui/material';
const TabCounterBadge = ({ count, isActive }) => {
    return count !== undefined ? (_jsx(Chip, { size: "small", color: isActive ? 'primary' : 'default', label: count, sx: { cursor: 'pointer', marginLeft: '.75rem', padding: '.125rem .125rem' } })) : (_jsx(Skeleton, { sx: { marginLeft: '.75rem' }, children: _jsx(Typography, { variant: "body2", children: "999" }) }));
};
export { TabCounterBadge };
